import api from './api';

const documentService = {
  // Get all documents with optional filters
  getAllDocuments: async (params = {}) => {
    const response = await api.get('/documents', { params });
    return response.data;
  },

  // Get documents for a specific patient
  getPatientDocuments: async (patientId) => {
    const response = await api.get(`/documents/patient/${patientId}`);
    return response.data;
  },

  // Upload document
  uploadDocument: async (formData) => {
    const response = await api.post('/documents/upload', formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Download document as blob (for viewing)
  downloadDocumentBlob: async (documentId) => {
    const response = await api.get(`/documents/${documentId}/download`, {
      responseType: 'blob', // Important: get as blob
    });
    return response.data;
  },

  // Download document (opens in new tab)
  getDocumentUrl: (documentId) => {
    const token = localStorage.getItem('access_token');
    return `${api.defaults.baseURL}/documents/${documentId}/download?token=${token}`;
  },

  // Delete document
  deleteDocument: async (id) => {
    const response = await api.delete(`/documents/${id}`);
    return response.data;
  },

  // Get document statistics
  getDocumentStats: async () => {
    const response = await api.get('/documents/stats');
    return response.data;
  },
};

export default documentService;